import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('mitoforge_token');
    const role = localStorage.getItem('mitoforge_role');
    
    if (!token || role !== 'admin') {
      navigate('/login');
      return;
    }

    fetch('/api/admin/dashboard', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(resData => {
        if (resData.message) throw new Error(resData.message);
        setData(resData);
      })
      .catch(err => setError(err.message));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  if (error) return <div style={{ color: 'red', textAlign: 'center', marginTop: '100px' }}>{error}</div>;
  if (!data) return <div style={{ color: '#fff', textAlign: 'center', marginTop: '100px' }}>Loading admin dashboard...</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#000', color: '#fff', paddingTop: '100px', paddingBottom: '60px' }}>
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
          <h1 style={{ margin: 0 }}>Super Admin Dashboard</h1>
          <button onClick={handleLogout} style={{ background: '#333', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}>Logout</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px', marginBottom: '40px' }}>
          <div style={{ background: '#111', padding: '24px', borderRadius: '8px', border: '1px solid #333' }}>
            <div style={{ color: '#888', fontSize: '0.9rem', marginBottom: '8px' }}>Total Sales (All Time)</div>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff' }}>₹{data.totalSales.toFixed(2)}</div>
          </div>
          <div style={{ background: '#111', padding: '24px', borderRadius: '8px', border: '1px solid #333' }}>
            <div style={{ color: '#888', fontSize: '0.9rem', marginBottom: '8px' }}>Total Orders</div>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff' }}>{data.totalOrders}</div>
          </div>
          <div style={{ background: '#111', padding: '24px', borderRadius: '8px', border: '1px solid #333' }}>
            <div style={{ color: '#888', fontSize: '0.9rem', marginBottom: '8px' }}>Registered Sellers</div>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff' }}>{data.sellers.length}</div>
          </div>
        </div>

        <h3 style={{ marginBottom: '16px', borderBottom: '1px solid #333', paddingBottom: '8px' }}>Verified Affiliate Sellers</h3>
        {data.sellers.length === 0 ? (
          <p style={{ color: '#888', marginBottom: '40px' }}>No sellers registered yet.</p>
        ) : (
          <div style={{ background: '#111', borderRadius: '8px', border: '1px solid #333', overflow: 'hidden', marginBottom: '40px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr style={{ background: '#1a1a1a', borderBottom: '1px solid #333' }}>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Name</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Email</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Affiliate Code</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Bank A/C</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>IFSC</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.sellers.map(seller => (
                  <tr key={seller.id} style={{ borderBottom: '1px solid #222' }}>
                    <td style={{ padding: '12px 16px' }}>{seller.name}</td>
                    <td style={{ padding: '12px 16px' }}>{seller.email}</td>
                    <td style={{ padding: '12px 16px', fontFamily: 'monospace', color: '#4caf50' }}>{seller.affiliate_code}</td>
                    <td style={{ padding: '12px 16px', fontFamily: 'monospace' }}>{seller.bank_account_number || '-'}</td>
                    <td style={{ padding: '12px 16px', fontFamily: 'monospace' }}>{seller.bank_ifsc || '-'}</td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ background: '#003300', color: '#4caf50', padding: '4px 8px', borderRadius: '12px', fontSize: '0.8rem' }}>{seller.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <h3 style={{ marginBottom: '16px', borderBottom: '1px solid #333', paddingBottom: '8px' }}>Recent Orders</h3>
        <div style={{ background: '#111', borderRadius: '8px', border: '1px solid #333', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
            <thead>
              <tr style={{ background: '#1a1a1a', borderBottom: '1px solid #333' }}>
                <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Date</th>
                <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Order ID</th>
                <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Customer</th>
                <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Total</th>
                <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Affiliate</th>
              </tr>
            </thead>
            <tbody>
              {data.orders.slice(0, 50).map(order => (
                <tr key={order.id} style={{ borderBottom: '1px solid #222' }}>
                  <td style={{ padding: '12px 16px' }}>{new Date(order.created_at).toLocaleDateString()}</td>
                  <td style={{ padding: '12px 16px', fontFamily: 'monospace' }}>{order.order_id}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <div>{order.customer_name}</div>
                    <div style={{ fontSize: '0.8rem', color: '#666' }}>{order.city}, {order.state}</div>
                  </td>
                  <td style={{ padding: '12px 16px' }}>{order.currency} {order.total_amount}</td>
                  <td style={{ padding: '12px 16px', fontFamily: 'monospace', color: order.affiliate_code ? '#4caf50' : '#666' }}>
                    {order.affiliate_code || '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
